"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  width: 50%;\n  height: 100vh;\n    .button-center {\n      text-align: center;\n      .general-default-button {\n        width: 160px;\n      }\n    }\n    .back-login {\n      text-align: center;\n      margin: 15px !important;\n      color: ", ";\n      cursor: pointer;\n      font-weight: bold;\n      font-family: ", ";\n      font-size: 13px;\n    }\n"])), _variables.GlobalColors.secondary_magenta, _variables.FontFamily.Raleway);

exports.Container = Container;